(function () {
    'use strict';

    angular
        .module('questionnaireTemplatesEditModule')
        .controller('ODDQuestionnaireTemplateSectionListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'questionnaireTemplate'];

    function Controller($scope, $state, topBarService, businessUnit, questionnaireTemplate) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');

        $scope.questionnaireTemplate = questionnaireTemplate;

        $scope.goToQuestionnaireTemplate = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', { ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID }, { reload: true });
        };
      
    }
})();